module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_office_color_red-db2f01d1098886aab21a235e7e184aa7.svg";